import { ApplicantId, CaseId } from '../types';
import { Fields } from './types';

import patchCase from './patch';
import patchApplicant from './applicants/patch';
import switchStatus from './switchStatus';
import { CaseStatus } from 'modules/cm/pages/CaseDetailsPage/CaseDetailsPage.types';
import changeProduct from './changeProduct';
import generateOfferPack from './generateOfferPack';
import generatePreOfferESIS from './generatePreOfferESIS';
import repaymentStrategy from '../repaymentStrategy';
import credit from '../credit';

const applicantApi = (endpoint: string) => (id: ApplicantId) => {
  const applicantEndpoint = `${endpoint}/applicant/${id}`;
  return {
    patch: (fields: Fields) => patchApplicant(applicantEndpoint)(fields),
  };
};

const api = (caseId: CaseId) => {
  const caseEndpoint = `/api/v1/cases/${caseId}`;
  return {
    applicantApi: applicantApi(caseEndpoint),
    patch: (fields: Fields) => patchCase(caseEndpoint)(fields),
    switchStatus: (status: CaseStatus) => switchStatus(caseEndpoint)(status),
    changeProduct: changeProduct(caseEndpoint),
    repaymentStrategyApi: repaymentStrategy(caseEndpoint),
    generateOfferPack: generateOfferPack(caseEndpoint),
    generatePreOfferESIS: generatePreOfferESIS(caseEndpoint),
    creditApi: credit(caseEndpoint),
  };
};

export default api;
